import type { Uuid } from '@liniya/api-client';

/**
 * Every cache key in one place.
 *
 * Realtime handlers update the cache from outside the component that filled
 * it, so a key spelled slightly differently in two files means an event
 * silently updates nothing. Building them from one object makes that class of
 * bug impossible to write.
 */
export const queryKeys = {
  config: ['config'] as const,
  session: ['session'] as const,
  profile: ['profile'] as const,
  devices: ['devices'] as const,
  chats: ['chats'] as const,
  chat: (chatId: Uuid) => ['chats', chatId] as const,
  messages: (chatId: Uuid) => ['messages', chatId] as const,
  search: (query: string) => ['search', query] as const,
  notificationConfig: ['notifications', 'config'] as const,
} as const;
